import { render, staticRenderFns } from "./delete-feecolumn.vue?vue&type=template&id=39e91b5c&scoped=true"
import script from "./delete-feecolumn.vue?vue&type=script&lang=js"
export * from "./delete-feecolumn.vue?vue&type=script&lang=js"
import style0 from "./delete-feecolumn.vue?vue&type=style&index=0&id=39e91b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e91b5c",
  null
  
)

export default component.exports